import { TextField, TextFieldProps } from '@mui/material'
import { useController, useFormContext } from 'react-hook-form'
import { UseControllerProps } from 'react-hook-form/dist/types'

import { PartialBy, safeCypressID } from '@/utils'

import { getError } from './utils'

export type VailNumberProps<T extends object> = PartialBy<
  UseControllerProps<T>,
  'control'
> &
  TextFieldProps & {
    asFloat?: boolean
    step?: number
  }

export const VailNumberInput = <T extends {}>(props: VailNumberProps<T>) => {
  const form = useFormContext<T>()
  if (!form)
    throw new Error('VailNumberInput must be used inside a FormProvider')
  const { formState } = form
  const errorMessage = getError(formState, props.name)
  const { control, name, rules, shouldUnregister, defaultValue, disabled } =
    props
  const { field } = useController({
    control: control || form.control,
    defaultValue,
    disabled,
    name,
    rules,
    shouldUnregister,
  })
  return (
    <TextField
      fullWidth
      id={safeCypressID(props.id ?? props.name)}
      inputRef={field.ref}
      type="number"
      {...field}
      error={!!errorMessage}
      helperText={errorMessage ?? props.helperText}
      inputProps={{
        pattern: 'd+(.d*)?',
        step: props.step ?? props.asFloat ? 0.1 : 1,
      }}
      label={props.label}
      value={String(
        props.asFloat
          ? parseFloat(field.value ?? props.defaultValue ?? '0')
          : parseInt(field.value ?? props.defaultValue ?? '0')
      )}
      onChange={(e) =>
        field.onChange(
          props.asFloat
            ? parseFloat(e.target.value || '0')
            : parseInt(e.target.value || '0')
        )
      }
    />
  )
}
